var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-scrollbar',{ref:"el-scrollbar",staticClass:"wind-scroll-bar",class:_vm.classes,style:(_vm.styles),attrs:{"wrapClass":_vm.wrapClass}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }